import { doc, setDoc, collection, getDocs, query, where, updateDoc, addDoc } from 'firebase/firestore';
    import { db } from '../lib/firebase';
    import { apiRequest } from '../lib/api';

    class SmsService {
      constructor() {
        this.twilioConfig = null;
        this.isConfigured = false;
      }

      async initialize() {
        try {
          const config = await this.getTwilioConfig();
          if (config) {
            this.twilioConfig = config;
            this.isConfigured = true;
          }
        } catch (error) {
          console.error(error);
        }
      }

      async getTwilioConfig() {
        try {
          const q = query(collection(db, 'smsConfig'), where('type', '==', 'twilio'));
          const snap = await getDocs(q);
          return !snap.empty ? snap.docs[0].data() : null;
        } catch (e) {
          return null;
        }
      }

      async saveTwilioConfig(config) {
        try {
          await setDoc(doc(db, 'smsConfig', 'twilio-config'), {
            ...config,
            type: 'twilio',
            updatedAt: new Date().toISOString()
          });
          this.twilioConfig = config;
          this.isConfigured = true;
          return { success: true };
        } catch (e) {
          return { success: false, message: e.message };
        }
      }

      // ✅ IMPROVED: Use centralized apiRequest
      async sendDirectSms(smsData) {
        try {
          const result = await apiRequest('/send-sms', {
            body: JSON.stringify(smsData)
          });
          return { success: true, ...result };
        } catch (error) {
          return { success: false, message: error.message };
        }
      }

      async sendSms(smsData) {
        if (!this.isConfigured) return { success: false, message: 'Twilio not configured' };
        
        if (smsData.type === 'test') {
          return this.sendDirectSms(smsData);
        }

        try {
          const logData = {
            to: smsData.to,
            body: smsData.body,
            status: 'pending',
            createdAt: new Date().toISOString()
          };
          const docRef = await addDoc(collection(db, 'smsLogs'), logData);
          return { success: true, smsId: docRef.id };
        } catch (e) {
          return { success: false, message: e.message };
        }
      }

      async getSmsLogs() {
        const snap = await getDocs(collection(db, 'smsLogs'));
        return snap.docs.map(d => ({ id: d.id, ...d.data() }));
      }
    }

    const smsService = new SmsService();
    export default smsService;